"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var Error = styled_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  color: ", ";\n"], ["\n  font-size: 13px;\n  color: ", ";\n"])), tokens_1.colors.text.error);
exports.default = Error;
var templateObject_1;
//# sourceMappingURL=error.js.map